import React, { useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Grid, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Card from "@mui/material/Card";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import { useState } from "react";
import { addTimeSpan, getRequestGroup, getSubRequestGroup, updateReservationTimeSpan } from "../../api/routes";
import MDInput from "../../components/MDInput/index";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import MDButton from "./../../components/MDButton/index";
import Table from "./Table";
import Footer from "examples/Footer";
import queryString from "../../components/queryString";
import { toast } from "react-toastify";

export default function ReservationTimeSpan() {
    const [requestGroupData, setRequestGroupData] = useState([]);
    const [subRequestGroupData, setSubRequestGroupData] = useState([]);
    const [clickedScenario, setClickedScenario] = useState();
    const timeInitialValue = "Fri Aug 05 2022 00:00:00 GMT+0430 (Iran Daylight Time)";
    const [startTime, setStartTime] = useState(timeInitialValue);
    const [endTime, setEndTime] = useState(timeInitialValue);
    const [endReservation, setEndReservation] = useState(timeInitialValue);
    const [requestGroupId, setRequestGroupId] = useState();
    const [subRequestGroupId, setSubRequestGroupId] = useState();
    const [isActive, setIsActive] = useState();
    const [patientNumber, setPatientNumber] = useState();

    useEffect(() => {
        const query = {
            all: 1,
        };
        getRequestGroup((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setRequestGroupData(data);
        }, queryString(query));
    }, []);

    const submitTimeSpan = () => {
        if (requestGroupId !== undefined && subRequestGroupId !== undefined && isActive !== undefined && patientNumber && startTime !== timeInitialValue && endTime !== timeInitialValue && endReservation !== timeInitialValue) {
            const data = {
                requestGroupId,
                subRequestGroupId,
                patientNumber,
                startTime: `${String(startTime.getHours()).padStart(2, "0")}:${String(startTime.getMinutes()).padStart(2, "0")}`,
                endTime: `${String(endTime.getHours()).padStart(2, "0")}:${String(endTime.getMinutes()).padStart(2, "0")}`,
                endReservationTime: `${String(endReservation.getHours()).padStart(2, "0")}:${String(endReservation.getMinutes()).padStart(2, "0")}`,
                isActive,
            };
            addTimeSpan(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else return window.location.reload();
            });
        } else return toast.error("تمام فیلد ها را پر کنید!");
    };
    const requestGroupChange = (event) => {
        setRequestGroupId(event.target.value);
        const index = requestGroupData.findIndex((item) => item.requestGroupId === event.target.value);

        if (index !== -1 && Number(requestGroupData[index].isActive) === 0) {
            toast.error("گروه غیرفعال است!");
        }
        getSubRequestGroup(event.target.value, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setSubRequestGroupData(data);
        });
    };
    const callback = (item) => {
        setClickedScenario(item);
        getSubRequestGroup(item.requestGroupId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setSubRequestGroupData(data);
        });
    };
    /* ----------------------- */
    const [check, setCheck] = useState({
        check1: false,
        check2: false,
        check3: false,
        check4: false,
        check5: false,
        check6: false,
        check7: false,
    });

    const openGroup = () => {
        setCheck((prev) => ({
            ...prev,
            check1: true,
        }));
    };
    const openSubGroup = () => {
        setCheck((prev) => ({
            ...prev,
            check2: true,
        }));
    };
    const clickedInput = () => {
        setCheck((prev) => ({
            ...prev,
            check3: true,
        }));
    };
    const openIsActive = () => {
        setCheck((prev) => ({
            ...prev,
            check4: true,
        }));
    };
    const openStartTime = () => {
        setCheck((prev) => ({
            ...prev,
            check5: true,
        }));
    };
    const openEndTime = () => {
        setCheck((prev) => ({
            ...prev,
            check6: true,
        }));
    };
    const openEndReservationTime = () => {
        setCheck((prev) => ({
            ...prev,
            check7: true,
        }));
    };
    /* --------------------------- */
    const updateTimeSpan = () => {
        const data = {
            timeSpanId: clickedScenario.timeSpanId,
            requestGroupId,
            subRequestGroupId,
            patientNumber,
            startTime: startTime !== timeInitialValue ? `${String(startTime.getHours()).padStart(2, "0")}:${String(startTime.getMinutes()).padStart(2, "0")}` : undefined,
            endTime: endTime !== timeInitialValue ? `${String(endTime.getHours()).padStart(2, "0")}:${String(endTime.getMinutes()).padStart(2, "0")}` : undefined,
            endReservationTime: endReservation !== timeInitialValue ? `${String(endReservation.getHours()).padStart(2, "0")}:${String(endReservation.getMinutes()).padStart(2, "0")}` : undefined,
            isActive,
        };
        updateReservationTimeSpan(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload();
        });
    };
    return (
        <>
            <DashboardLayout>
                <MDBox pt={2} mb={6}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg"
                                    coloredShadow="info" style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}>
                                    <MDTypography variant="h6" color="white">
                                        ثبت بازه زمانی سناریو
                                    </MDTypography>
                                    <DashboardNavbar />
                                </MDBox>
                                <MDBox pt={4} pb={3} px={3}>
                                    <FormControl sx={{ width: "364.5px", margin: "0.5rem" }}>
                                        <InputLabel>گروه</InputLabel>
                                        <Select
                                            value={check.check1 ? requestGroupId : clickedScenario?.requestGroupId || ""}
                                            onOpen={openGroup} onChange={requestGroupChange} label="گروه"
                                            sx={{ height: "44.3px" }}>
                                            {requestGroupData.map((item) =>
                                                <MenuItem key={item.requestGroupId}
                                                    value={item.requestGroupId}>{item.nameGroup} {item.isNoteBook ? " ** دفتر نوبت دهی **" : ""}</MenuItem>,
                                            )}
                                        </Select>
                                    </FormControl>
                                    <FormControl sx={{ width: "364.5px", margin: "0.5rem" }}>
                                        <InputLabel>زیر گروه</InputLabel>
                                        <Select
                                            value={check.check2 ? subRequestGroupId : clickedScenario?.subRequestGroupId || ""}
                                            onChange={(event) => setSubRequestGroupId(event.target.value)}
                                            onOpen={openSubGroup} label="زیر گروه" sx={{ height: "44.3px" }}>
                                            {subRequestGroupData.map((item) =>
                                                <MenuItem key={item.subRequestGroupId}
                                                    value={item.subRequestGroupId}>{item.subNameGroup}</MenuItem>,
                                            )}
                                        </Select>
                                    </FormControl>
                                    <MDInput type="text"
                                        value={check.check3 ? patientNumber : clickedScenario?.patientNumber || ""}
                                        onClick={clickedInput}
                                        onChange={(event) => setPatientNumber(event.target.value)}
                                        label="تعداد بیمار" sx={{ width: "364.5px", margin: "0.5rem" }} />
                                    <FormControl sx={{ width: "364.5px", margin: "0.5rem" }}>
                                        <InputLabel>وضعیت نوبت دهی</InputLabel>
                                        <Select value={check.check4 ? isActive : clickedScenario?.isActive ? 1 : 0}
                                            onChange={(event) => setIsActive(event.target.value)}
                                            onOpen={openIsActive} label="وضعیت نوبت دهی" sx={{ height: "44.3px" }}>
                                            <MenuItem value={1}>فعال</MenuItem>
                                            <MenuItem value={0}>غیر فعال</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <section style={{ marginTop: "2rem" }}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <TimePicker
                                                ampm={false}
                                                openTo="hours"
                                                views={["hours", "minutes"]}
                                                inputFormat="HH:mm"
                                                mask="__:__"
                                                label="زمان شروع"
                                                value={check.check5 ? startTime : (clickedScenario?.startTime && `Fri Aug 05 2022 ${clickedScenario?.startTime}:00 GMT+0430 (Iran Daylight Time)`) || timeInitialValue}
                                                onChange={(newValue) => {
                                                    setStartTime(newValue);
                                                }}
                                                renderInput={(params) => <TextField onClick={openStartTime} sx={{
                                                    width: "364.5px",
                                                    margin: "0.5rem",
                                                }} {...params} />}
                                            />
                                            <TimePicker
                                                ampm={false}
                                                openTo="hours"
                                                views={["hours", "minutes"]}
                                                inputFormat="HH:mm"
                                                mask="__:__"
                                                label="زمان پایان"
                                                value={check.check6 ? endTime : (clickedScenario?.endTime && `Fri Aug 05 2022 ${clickedScenario?.endTime}:00 GMT+0430 (Iran Daylight Time)`) || timeInitialValue}
                                                onChange={(newValue) => {
                                                    setEndTime(newValue);
                                                }}
                                                renderInput={(params) => <TextField onClick={openEndTime} sx={{
                                                    width: "364.5px",
                                                    margin: "0.5rem",
                                                }} {...params} />}
                                            />
                                            <TimePicker
                                                ampm={false}
                                                openTo="hours"
                                                views={["hours", "minutes"]}
                                                inputFormat="HH:mm"
                                                mask="__:__"
                                                label="زمان توقف نوبت دهی"
                                                value={check.check7 ? endReservation : (clickedScenario?.endReservationTime && `Fri Aug 05 2022 ${clickedScenario?.endReservationTime}:00 GMT+0430 (Iran Daylight Time)`) || timeInitialValue}
                                                onChange={(newValue) => {
                                                    setEndReservation(newValue);
                                                }}
                                                renderInput={(params) => <TextField onClick={openEndReservationTime}
                                                    sx={{
                                                        width: "364.5px",
                                                        margin: "0.5rem",
                                                    }} {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </section>
                                </MDBox>
                                <MDButton onClick={clickedScenario ? updateTimeSpan : submitTimeSpan} variant="gradient"
                                    color="info" sx={{ width: "140px", margin: "1rem 0 1rem 2rem" }}>
                                    {clickedScenario ? <p>ویرایش بازه زمانی</p> : <p>ثبت بازه زمانی</p>}
                                </MDButton>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                <Table callback={callback} />
                <Footer />
            </DashboardLayout>
        </>
    );
}
